import React, { FC, ReactNode } from 'react';
import { Switch, FormControlLabel, FormControl, FormHelperText } from '@mui/material';
import { FastField, FieldProps } from 'formik';

interface FormFieldSwitchProps {
  label: string | ReactNode;
  name: string;
  readonly?: boolean;
  autoFocus?: boolean;
}

const FormFieldSwitch: FC<FormFieldSwitchProps> = ({ label, name, readonly, autoFocus }: FormFieldSwitchProps) => (
  <FastField name={name}>
    {({ field, meta, form }: FieldProps<boolean>) => {
      const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        form.setFieldValue(name, event.target.checked);
        form.setFieldTouched(name, true, false);
      };

      return (
        <FormControl error={!!meta.error && meta.touched}>
          <FormControlLabel
            id={field.name}
            control={
              <Switch
                checked={field.value ?? false}
                onChange={handleChange}
                autoFocus={autoFocus}
                name={field.name}
                onBlur={field.onBlur}
                color="primary"
              />
            }
            label={label}
            disabled={readonly}
          />
          {meta.error && meta.touched && <FormHelperText>{meta.error}</FormHelperText>}
        </FormControl>
      );
    }}
  </FastField>
);

export default FormFieldSwitch;
